export default "__VITE_ASSET__CBUDG39b__"